export class WithdrawalMethodIn {
    id: string = ""
    type: string = "MOBILE_MONEY"
    operator_id: string = ""
    identifier: string = ""
}
